import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { cpf, cnpj } from 'cpf-cnpj-validator';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';
import { SelectButton } from 'primereact/selectbutton';
import { Toast } from 'primereact/toast';

import { useFormCreateContrato } from 'src/controllers/Contrato/CreateContratoController';
import LoadingScreen from 'src/components/LoadingScreen';
import { useHistory } from 'react-router-dom';

interface InputMaskProps {
	label: string;
	mask: string;
	placeholder: string;
}

const ContratoForm: React.FC = () => {
	const { getContratoFormController, handleContratoFormController } = useFormCreateContrato();
	const [registerFinished, setRegisterFinished] = useState(false);

	const history = useHistory();


	useEffect(() => {
		if (getContratoFormController.contratoResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (
			getContratoFormController.contratoEditedResponse?.status === 200 &&
			!getContratoFormController.contratoResponse
		) {
			setRegisterFinished(false);
		}
	}, [getContratoFormController.contratoResponse, getContratoFormController.contratoEditedResponse]);


	return (
		<div style={{ height: '100%' }} className='card p-align-center p-justify-center'>
			<Toast ref={getContratoFormController.toast} />
			<h5>Cadastro de Contratos</h5>
			{getContratoFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<form className='p-grid p-fluid'>
				<div className='p-field p-col-12 p-md-2'>
					<label htmlFor='nomeComp'>Data Início</label>
					<InputMask
						type={'text'}
						mask='99/99/9999'
						value={getContratoFormController.formik.values.DATAINICIO}
						onChange={e => {
							getContratoFormController.formik.setFieldValue('DATAINICIO', e.target.value);
						}}
						placeholder='__/__/____'
					/>
					<div className={classNames("p-invalid popup-fade", {
						'popup-form-active': getContratoFormController.formik.touched.DATAINICIO && getContratoFormController.formik.errors.DATAINICIO,
						'popup-form-inactive': !(getContratoFormController.formik.touched.DATAINICIO && getContratoFormController.formik.errors.DATAINICIO),
					})}
					>{getContratoFormController.formik.errors.DATAINICIO}</div>
				</div>

				<div className='p-field p-col-12 p-md-2'>
					<label htmlFor='banco'>DATA FIM</label>
					<InputMask
						type={'text'}
						mask='99/99/9999'
						value={getContratoFormController.formik.values.DATAFIM}
						onChange={e => {
							getContratoFormController.formik.setFieldValue('DATAFIM', e.target.value);
						}}
						placeholder='__/__/____'
					/>
					<div className={classNames("p-invalid popup-fade", {
						'popup-form-active': getContratoFormController.formik.touched.DATAFIM && getContratoFormController.formik.errors.DATAFIM,
						'popup-form-inactive': !(getContratoFormController.formik.touched.DATAFIM && getContratoFormController.formik.errors.DATAFIM),
					})}
					>{getContratoFormController.formik.errors.DATAFIM}</div>
				</div>



				<div className='p-field p-col-12 p-md-2'>
					<label htmlFor='conta'>NUMERO</label>
					<InputText
						id='NUMERO'
						// maxlength={20}
						disabled={registerFinished}
						{...getContratoFormController.formik.getFieldProps('NUMERO')}
						onChange={(e) => getContratoFormController.formik.setFieldValue('NUMERO', e.currentTarget.value)}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getContratoFormController.formik.touched.NUMERO &&
								getContratoFormController.formik.errors.NUMERO,
							'popup-form-inactive': !(
								getContratoFormController.formik.touched.NUMERO &&
								getContratoFormController.formik.errors.NUMERO
							),
						})}>
						{getContratoFormController.formik.errors.NUMERO}
					</div>
				</div>
				<div className='p-field p-col-12 p-md-2'>
					<label htmlFor='conta'>TAXA ADM</label>
					<InputText
						id='TAXAADM'
						// maxlength={20}
						disabled={registerFinished}
						{...getContratoFormController.formik.getFieldProps('TAXAADM')}
						onChange={(e) => getContratoFormController.formik.setFieldValue('TAXAADM', e.currentTarget.value)}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getContratoFormController.formik.touched.TAXAADM &&
								getContratoFormController.formik.errors.TAXAADM,
							'popup-form-inactive': !(
								getContratoFormController.formik.touched.TAXAADM &&
								getContratoFormController.formik.errors.TAXAADM
							),
						})}>
						{getContratoFormController.formik.errors.TAXAADM}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-2'>
					<label htmlFor='VALOR'>VALOR DO CONTRATO</label>
					<InputNumber
						id='VALOR'
						disabled={registerFinished}
						value={getContratoFormController.formik.values.VALOR ?? 0}
						onValueChange={(e) => getContratoFormController.formik.setFieldValue('VALOR', e.value)}
						mode="currency"
						currency="BRL"
						locale="pt-BR"
					/>
				</div>

				<div className='p-field p-col-12 p-md-8'>
					<label htmlFor='conta'>DESCRICAO</label>
					<InputText
						id='DESCRICAO'
						// maxlength={20}
						disabled={registerFinished}
						{...getContratoFormController.formik.getFieldProps('DESCRICAO')}
						onChange={(e) => getContratoFormController.formik.setFieldValue('DESCRICAO', e.currentTarget.value)}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getContratoFormController.formik.touched.DESCRICAO &&
								getContratoFormController.formik.errors.DESCRICAO,
							'popup-form-inactive': !(
								getContratoFormController.formik.touched.DESCRICAO &&
								getContratoFormController.formik.errors.DESCRICAO
							),
						})}>
						{getContratoFormController.formik.errors.DESCRICAO}
					</div>
				</div>



			</form>

			<div className='p-fluid p-grid p-justify-between'>
				{getContratoFormController.contratoResponse?.status === 200 && !registerFinished ? (
					<div className='p-col-12 p-md-4'>
						<Button
							type='button'
							label='Salvar Alterações'
							onClick={() => {
								getContratoFormController.formik.handleSubmit();
							}}
						/>
					</div>
				) : getContratoFormController.contratoResponse?.status === 200 && registerFinished ? (
					<div className='p-col-12 p-md-6 p-fluid p-grid'>
						<div className='p-col-12 p-md-5'>
							<Button
								type='button'
								label='Editar'
								onClick={() => {
									setRegisterFinished(false);
								}}
							/>
						</div>
						<div className='p-col-12 p-md-5'>
							<Button
								icon='pi pi-plus'
								type='button'
								className='p-button-success'
								label='Cadastrar novo'
								onClick={() => {
									getContratoFormController.formik.resetForm();
									setRegisterFinished(false);
									handleContratoFormController.setContratoResponse(null);
								}}
							/>
						</div>
					</div>
				) : (
					<div className='p-col-12 p-md-4'>
						<Button
							type='button'
							label='Cadastrar'
							onClick={() => {
								console.log('values:', getContratoFormController.formik.values);
								console.log('errors:', getContratoFormController.formik.errors);
								console.log('isValid:', getContratoFormController.formik.isValid);
								getContratoFormController.formik.handleSubmit();
							}}
						/>
					</div>
				)}

				<div className='p-col-12 p-md-6 p-fluid p-grid'>
					<div className='p-col-6'>
						<Button
							type='button'
							label='Limpar'
							onClick={() => {
								getContratoFormController.formik.resetForm();
							}}
						/>
					</div>
					<div className='p-col-6'>
						<Button
							type='button'
							className='p-button-secondary'
							label='Voltar para listagem'
							onClick={() => history.goBack()}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContratoForm;
